export default __webpack_public_path__ + "177b86acc07082d5ef89efee2833a7f1.svg";